import React, { useEffect, useState } from 'react';
import {Link, useParams} from 'react-router-dom';
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import UserAPI from "../../../apis/adminApi/userAPI";
import StationAPI from "../../../apis/adminApi/stationAPI";
import FormContentLoader from "../../loaders/FormContentLoader";
import Field from "../../forms/Field";
import Select from "../../forms/Select";
import {useForm} from "react-hook-form";
import MyButton from "../../assets/MyButton";

const AffectStations = () => {

    const [showLoader, setShowLoader] = useState(false);

    const { formState } = useForm();
    const { isSubmitting } = formState;
    let {stationnaireId} = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [stations, setStations] = useState("");
    const [stationnaire, setStationnaire] = useState({
        name : "",
        staId : "",
        id : stationnaireId
    });

    const [errors, setErrors] = useState({
        name : "",
        staId : "",
    });

    //Recuperation d'une facture
    const fetchUser = async stationnaireId => {
        try{
            const { id, name, email, phone, city, role, actived, pvId } = await UserAPI.findStationnaire(stationnaireId);
            setStationnaire({ id, name, email, phone, city, role, actived, pvId });
            setLoading(false);
        }catch(error){
            toast.error("Impossible de charger l'utilisateur démandé !");
            navigate("/admin/usersStations");
        }
    };

    const fetchStations = async () => {
        try{
            const stations = await StationAPI.findAll();
            setStations(stations);
            setLoading(false);
        }catch(error){
            toast.error("Impossible de charger les points de vente démandés !");
            navigate("/admin/usersStations");
        }
    };

    useEffect(() => {
        setLoading(true);
        fetchStations()
    },[]);


    useEffect(() => {
        setLoading(true);
        fetchUser(stationnaireId);
    },[stationnaireId]);



    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setStationnaire({...stationnaire, [name] : value});
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{

            setShowLoader(true);
            await UserAPI.affectToStation(stationnaire, stationnaireId);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Utilisateur affecté avec succès");
            navigate("/admin/usersStations");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {error} = response.data;
            if (error) {
                toast.error(error);
            }
        }
    };

    let redirect = "";
    if (stationnaire.role === "ROLE_VENDOR") {
        redirect = "stationnaires";
    }else if (stationnaire.role === "ROLE_FRET") {
        redirect = "fretOperateurs";
    }else if (stationnaire.role === "ROLE_STATION") {
        redirect = "usersStations";
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    {loading && <FormContentLoader />}
                    {!loading && <form onSubmit={handleSubmit}>
                                <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">Modifier un stationnaire</h5>

                                        <Field
                                            name="name"
                                            value={stationnaire.name}
                                            onChange={handleChange}
                                            label="Nom Complet"
                                            disabled="disabled"
                                        />

                                        {stations && <Select name="staId" label="Station" value={stationnaire.staId} error={errors.staId} onChange={handleChange}>
                                            <option value="">Choisir</option>
                                            {stations.map(station =>
                                                <option key={station.id} value={station.id}>
                                                    {station.station_city} - {station.station_name}
                                                </option>)
                                            }
                                        </Select>}



                                        <MyButton
                                            text="Modifier"
                                            onSubmit={handleSubmit}
                                            loading={showLoader}
                                            disabled={showLoader}
                                        />
                                        <Link to={`/admin/${redirect}`} className="btn btn-info mx-2">Annuler</Link>
                                    </div>
                                </div>
                            </form>}
                </div>
            </div>
        </div>
    );
};

export default AffectStations;
